import AccidentReports from '../../components/AccidentReports';
import { Button } from '../../components/ui/button';
import React, { useEffect, useState } from 'react';
import { portalApi, formatApiError } from '../../services/api';
import { FileText, Car } from '@phosphor-icons/react';
import { toast } from 'sonner';

const fmtEUR = (v) => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(Number(v || 0));

export default function PortalBookings() {
  const [accidentBooking, setAccidentBooking] = useState(null);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const r = await portalApi.bookings();
        setItems(r.data || []);
      } catch (err) { toast.error(formatApiError(err)); }
      finally { setLoading(false); }
    })();
  }, []);

  return (
    <div className="p-6 space-y-6" data-testid="portal-bookings-page">
      <div>
        <h1 className="text-3xl font-bold tracking-tight text-[#111418]">Buchungen</h1>
        <p className="text-[#525866] mt-1">Ihre Mietbuchungen</p>
      </div>

      {loading ? (
        <div className="card-swiss h-24 skeleton" />
      ) : items.length === 0 ? (
        <div className="card-swiss p-12 text-center">
          <FileText weight="thin" size={64} className="mx-auto text-[#8A94A6] mb-4" />
          <p className="text-[#525866]">Sie haben aktuell keine Buchungen.</p>
        </div>
      ) : (
        <div className="card-swiss overflow-hidden">
          <table className="table-swiss">
            <thead><tr><th>Buchung</th><th>Fahrzeug</th><th>Zeitraum</th><th className="text-right">Preis</th><th>Status</th><th>Dokumente</th></tr></thead>
            <tbody>
              {items.map((b) => (
                <tr key={b.id} data-testid={`portal-booking-row-${b.id}`}>
                  <td className="font-semibold">{b.booking_number || b.id.slice(0, 8)}</td>
                  <td className="text-sm">
                    <div className="flex items-center gap-2">
                      <Car weight="bold" size={14} />
                      {b.vehicle?.brand} {b.vehicle?.model}
                    </div>
                    <p className="text-xs text-[#8A94A6]">{b.vehicle?.license_plate}</p>
                  </td>
                  <td className="text-sm text-[#525866]">{b.start_date} → {b.end_date}</td>
                  <td className="text-right font-semibold">{fmtEUR(b.price_info?.total_price || 0)}</td>
                  <td><span className="text-xs px-2 py-1 rounded bg-[#F5F7FA] text-[#525866] font-semibold">{b.status}</span></td>
                  <td><Button variant="outline" size="sm" onClick={()=>setAccidentBooking(b)}>Unfall melden</Button><br/><a href={portalApi.accidentReportUrl(b.id)} className="text-sm underline text-[#E60000] whitespace-nowrap">Unfallbericht herunterladen</a></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {accidentBooking && <AccidentReports booking={accidentBooking} onClose={()=>setAccidentBooking(null)}/>}
    </div>
  );
}
